import {NewsArticleState} from './news-article.state';
import {DirectionDTO} from '../../../../openapi/agrarinformationen-openapi';


export const newsArticleStateInitial: NewsArticleState = {
  currentNewsId: undefined,
  currentNewsLoading: false,
  currentNewsLoaded: false,
  latestNewsIds: [],
  latestNewsLoading: false,
  latestNewsLoaded: false,
  latestNewsTotalElements: 0,
  latestNewsPageableDto: {
    size: 4,
    number: 0,
    property: ['createdAt'],
    direction: [DirectionDTO.Desc],
  },
}
